// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"e01f3a00","39":"27d0c79c","308":"1ebdf971","353":"cf64b76e","428":"65ce8a4c","448":"65ce8a4c","488":"cf64b76e","598":"7b18fd02","614":"e01f3a00","753":"b1e8291c","806":"336a0168","910":"336a0168","961":"37130db1"}[chunkId] + ".chunk.css";
};